import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

import type { LayerState, LayerId, LayerConfig } from '../types/map.types';

/** Satellite basemap, GEE AlphaEarth, flood, and six infrastructure types only. */
export const DEFAULT_LAYER_CONFIGS: LayerConfig[] = [
  { id: 'gee', name: 'GEE AlphaEarth', visible: false, opacity: 0.65 },
  { id: 'flood', name: 'Ngập lụt', visible: false, opacity: 1 },
  { id: 'pumps', name: 'Trạm bơm', visible: false, opacity: 1 },
  { id: 'culverts', name: 'Cống thoát nước', visible: false, opacity: 1 },
  { id: 'canals', name: 'Kênh mương', visible: false, opacity: 1 },
  { id: 'dykes', name: 'Đê điều', visible: false, opacity: 1 },
  { id: 'lowlying', name: 'Vùng trũng', visible: false, opacity: 1 },
  { id: 'landslides', name: 'Khu cảnh báo sạt lở', visible: false, opacity: 1 },
];

const initialState: LayerState = {
  layers: DEFAULT_LAYER_CONFIGS.map((l) => ({ ...l })),
};

const layerSlice = createSlice({
  name: 'layer',
  initialState,
  reducers: {
    setLayerVisible(state, action: PayloadAction<{ id: LayerId; visible: boolean }>) {
      const layer = state.layers.find((l) => l.id === action.payload.id);
      if (layer) layer.visible = action.payload.visible;
    },
    setLayerOpacity(state, action: PayloadAction<{ id: LayerId; opacity: number }>) {
      const layer = state.layers.find((l) => l.id === action.payload.id);
      if (layer) layer.opacity = action.payload.opacity;
    },
    addLayer(state, action: PayloadAction<LayerConfig>) {
      if (!state.layers.find((l) => l.id === action.payload.id)) {
        state.layers.push(action.payload);
      }
    },
    resetLayersToDefault(state) {
      state.layers = DEFAULT_LAYER_CONFIGS.map((l) => ({ ...l }));
    },
  },
});

export const { setLayerVisible, setLayerOpacity, addLayer, resetLayersToDefault } =
  layerSlice.actions;
export default layerSlice.reducer;
